import { httpOk, PATCH} from 'helpers/api'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

const initData = {
	min_level: '',
};

function MinLevel({ modal, setModal, getData, id }) {
	const { t } = useTranslation();

	const [sendData, setSendData] = useState({ ...initData })

	async function create() {
		var sendDataCopy = { ...sendData }
		delete sendDataCopy.unit_id;
		const response = await PATCH(`/inventory/raw-warehouse/items/${id}/min-level/`, sendDataCopy)
		if (httpOk(response)) {
			setModal(false);
			setSendData({ ...initData });
			getData();
		}
	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('edit_min_level')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('edit_min_level_description')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('quantity')}</label>
						<input type="number" placeholder='0' name="min_level"
							value={sendData.min_level} onChange={(e) => handleChange(e)} />
					</div>
				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={() => create()}>
						{t('save')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default MinLevel